import React, { useEffect, useState } from "react";
import { Button, Grid, } from "@mui/material";
import { Dialog } from "../../../Components/Dialogs/Dialog";
import { OutlinedTextField } from "../../../Components/formComponents";
import { useFormik } from "formik";
import { useAppDispatch } from "../../../redux";
import { createBlankLayoutWithCallbackAsync, defaultTablesLayout, ITablesLayout } from "../../../redux/tables";
import { useOutletContext } from '../../../providers';


export interface ICreateNewLayoutDialogProps {
    layout_info?: ITablesLayout
    onSuccess: (data: ITablesLayout) => void
}


export const CreateNewLayoutButton: React.FC<ICreateNewLayoutDialogProps> = React.memo((
    props
) => {
    const { layout_info, onSuccess } = props;
    const dispatch = useAppDispatch();
    const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext();
    const [openCreateDialog, setOpenCreateDialog] = useState(false);

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        setValues,
        setFieldValue,
        isSubmitting,
        setSubmitting
    } = useFormik({
        initialValues: defaultTablesLayout,
        validate: (values) => {
            const errors: any = {};
            if (!values.layout_name) {
                errors.layout_name = "*This field is required.";
            }
            return errors;
        },
        onSubmit: async (values) => {
            setSubmitting(true)
            dispatch(createBlankLayoutWithCallbackAsync({
                payload: {
                    ...defaultTablesLayout,
                    layout_name: values.layout_name,
                    ...(!values.layout_uuid && {
                        outlet_uuid: outlet_uuid || "",
                        outlet_name: outlet_name || ""
                    })
                },
                onCallback(isSuccess, data) {
                    if (isSuccess && data) {
                        onSuccess(data)
                    }
                }
            })).finally(() => {
                setSubmitting(false)
                setOpenCreateDialog(false)
            });


            // .then((res) => {
            //     if (res.meta.requestStatus === "fulfilled") {
            //         // window.location.reload()
            //     }
            // })
        },
    });

    useEffect(() => {
        if (!layout_info) return
        setValues(layout_info)
    }, [layout_info])


    return (
        <>
            <Button variant="contained" onClick={() => setOpenCreateDialog(true)}>Create Layout</Button>
            <Dialog
                open={openCreateDialog}
                title="Add/Edit Layout"
                size="sm"
                contentWrappedWithForm={{ onSubmit: handleSubmit }}
                onClose={() => setOpenCreateDialog(false)}
                actions={[
                    {
                        type: "button",
                        variant: "outlined",
                        label: "Cancel",
                        onClick: () => setOpenCreateDialog(false),
                    },
                    {
                        type: "submit",
                        variant: "contained",
                        disabled: isSubmitting,
                        label: "Create",
                    },
                ]}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <OutlinedTextField
                            label="Layout Name"
                            id="layout_name"
                            multiline
                            minRows={2}
                            value={values.layout_name}
                            onChange={handleChange}
                            error={errors.layout_name}
                        />
                    </Grid>
                </Grid>
            </Dialog>
        </>
    );
});
